import CloseIcon from '@mui/icons-material/Close';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { FC, useState } from 'react';
import styles from './GenerateSegmentsModal.module.scss';

/* istanbul ignore file */

interface Props {
  open: boolean;
  isSubmitting: boolean;
  handleClose(): void;
  handleSubmit(numberOfSegments: number): Promise<void> | void;
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  minWidth: '300px',
  maxWidth: '420px',
  bgcolor: 'var(--white)',
  borderRadius: '8px',
};

const MIN_SEGMENTS = 1;
const MAX_SEGMENTS = 100;

const GenerateSegmentsModal: FC<Props> = ({ open, isSubmitting, handleClose, handleSubmit }) => {
  const [value, setValue] = useState<string>('1');

  const parsed = Number.parseInt(value, 10);
  const isValid = Number.isFinite(parsed) && parsed >= MIN_SEGMENTS && parsed <= MAX_SEGMENTS;

  const onSubmit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    if (!isValid || isSubmitting) return;
    await handleSubmit(parsed);
  };

  return (
    <Modal className={styles.modal} open={open} onClose={handleClose} disableScrollLock>
      <Box sx={style}>
        <form className={styles.container} onSubmit={onSubmit}>
          <div className={styles.header}>
            <Typography className={styles.title}>Generate Segments</Typography>
            <button
              type="button"
              className={styles.closeButton}
              onClick={handleClose}
              aria-label="Close"
            >
              <CloseIcon fontSize="small" />
            </button>
          </div>
          <div className={styles.body}>
            <label className={styles.field}>
              <span className={styles.label}>Number of segments</span>
              <input
                className={styles.input}
                type="number"
                min={MIN_SEGMENTS}
                max={MAX_SEGMENTS}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                disabled={isSubmitting}
                autoFocus
              />
            </label>
            <Typography className={styles.hint}>
              Each segment will be 120s long with a 120s gap. Sequence numbers continue from the
              worker&apos;s current count.
            </Typography>
          </div>
          <div className={styles.actions}>
            <button
              type="button"
              className={styles.cancelButton}
              onClick={handleClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={styles.confirmButton}
              disabled={!isValid || isSubmitting}
            >
              {isSubmitting ? 'Generating...' : 'Generate'}
            </button>
          </div>
        </form>
      </Box>
    </Modal>
  );
};

export default GenerateSegmentsModal;
